import { api } from './api';

export const vendorApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getVendors: builder.query({
      query: ({
        order,
        orderBy,
        filter,
        page,
        pageSize,
        dateRange,
      }) => ({
        url: 'getVendors',
        method: 'POST',
        body: {
          order,
          orderBy,
          filter,
          page,
          pageSize,
          dateRange,
        },
      }),
      providesTags: ['Vendors'],
    }),

    getVendor: builder.mutation({
      query: ({
        order,
        orderBy,
        filter,
        vendorId,
        vendorIndex,
      }) => ({
        url: 'getVendor',
        method: 'POST',
        body: {
          order,
          orderBy,
          filter,
          vendorId,
          vendorIndex,
        },
      }),
    }),

    saveVendor: builder.mutation({
      query: (vendorData) => ({
        url: 'saveVendor',
        method: 'POST',
        body: vendorData,
      }),
      invalidatesTags: ['Vendors'],
    }),

    deleteVendor: builder.mutation({
      query: ({
        order,
        orderBy,
        filter,
        page,
        pageSize,
        id,
        vendorId,
      }) => ({
        url: 'deleteVendor',
        method: 'POST',
        body: {
          order,
          orderBy,
          filter,
          page,
          pageSize,
          vendorId: vendorId || id,
        },
      }),
      invalidatesTags: ['Vendors'],
    }),

    getActiveVendors: builder.query({
      query: () => ({
        url: 'getActiveVendors',
      }),
      providesTags: ['Vendors'],
    }),
  }),
});

export const {
  useGetVendorsQuery,
  useGetVendorMutation,
  useSaveVendorMutation,
  useDeleteVendorMutation,
  useGetActiveVendorsQuery,
} = vendorApi;
